<template>
  <div class="fabric-detail">
    <DetailHead :data="rowData" />
    <DetailMain :data="detailData" :loading="loading" />
  </div>
</template>

<script>
import DetailHead from "./head.vue";
import DetailMain from "./main.vue";

export default {
  name: "FabricDetail",
  components: {
    DetailHead,
    DetailMain,
  },
  props: {
    rowData: {},
  },
  data() {
    return {
      loading: false,
      detailData: [],
    };
  },

  mounted() {
    this.loadDetailData();
  },
  methods: {
    loadDetailData() {
      if (!this.rowData || !this.rowData.fabricColorNo) {
        return;
      }
      this.loading = true;
      this.$api
        .fabricStockInDetailByColorApi({
          fabricColorNo: this.rowData.fabricColorNo,
        })
        .then((res) => {
          this.detailData = res.body.data;
        })
        .catch((err) => {
          console.error("加载详情数据失败:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fabric-detail {
  padding: 0;
  background: #fff;
}
</style>
